import ContractGridFloatingFilter from './ContractGridFloatingFilter';

export default ContractGridFloatingFilter;
